<template>
  <div class="px-2 mt-10 sm:container mx-auto">
    <h2 class="text-xl text-bold">จับยี่กี {{ yeekeeName() }}</h2>
    <ResultSwitchTab :slug="props.slug" :tab="props.tab"></ResultSwitchTab>
    <div class="grid grid-cols-1 gap-4 mt-2" v-if="!pending">
      <div class="border border-gray-200 rounded-md shadow w-full">
        <div
          class="p-2 d-flex justify-center"
          :class="gameColorHeader(props.slug)"
        >
          <span
            class="text-lg px-2 text-bold basis-1/6 grid justify-items-start"
          >
            <svg
              @click="toggleDataPrevious()"
              class="w-6 h-6 text-gray-800 dark:text-white text-right cursor-pointer"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
              ></path>
            </svg>
          </span>
          <span class="text-lg text-center px-2 text-bold grow"
            >จับยี่กี {{ yeekeeName() }} รอบ {{ current }}</span
          >
          <span class="text-lg px-2 text-bold basis-1/6 grid justify-items-end">
            <svg
              @click="toggleDataNext()"
              class="w-6 h-6 text-gray-800 dark:text-white cursor-pointer"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
              ></path>
            </svg>
          </span>
        </div>
        <div class="grid grid-cols-2 p-2 divide-x divide-gray-200">
          <div class="text-center">
            <p class="text-sm">สามตัวบน</p>
            <p class="text-lg text-bold">
              {{ getResultUpper() }}
            </p>
          </div>
          <div class="text-center">
            <p class="text-sm">สองตัวล่าง</p>
            <p class="text-lg text-bold">
              {{ getResultUnder() }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="datas"
      class="flex flex-wrap justify-start gap-2 md:gap-3 lg:gap-2 mt-2 px-0 md:px-0 lg:px-2"
    >
      <div
        v-for="(item, index) in datas"
        :key="index"
        class="w-8 h-8 lg:w-10 lg:h-10 grid content-center text-center rounded-sm shadow cursor-pointer hover:text-white"
        :class="
          item.round_no == current
            ? buttonColorChange(props.slug)
            : 'bg-gray-200 text-black'
        "
        @click="toggleData(item.round_no)"
      >
        {{ item.round_no }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { set, useArrayFind, useToNumber, useToString } from "@vueuse/core";
const props = defineProps({
  slug: String,
  tab: String,
  currenGame: String,
});
const yeekeeName = () => {
  if (props.slug === "yeekee_5") {
    return "5 นาที";
  } else {
    return "15 นาที";
  }
};
const config = useRuntimeConfig();
const base_api = config.public.apiUri;
const timeformatted = useDateFormat(useNow(), "H");
const dateNow = () => {
  const date = new Date();
  if (timeformatted.value < 5) {
    date.setDate(date.getDate() - 1);
    return useDateFormat(date, "YYYY-MM-DD");
  }
  return useDateFormat(date, "YYYY-MM-DD");
};
const apiUrl = ref(
  `${base_api}/result/yeekee/${props.slug}/${dateNow().value}`
);
const { data: datas, pending } = await useLazyFetch(apiUrl.value);
const { gameColorHeader } = useUtils();
const current = ref(32);
const buttonClass = ref(null);

const arrayFind = ref(null);

function toggleData(data) {
  set(current, data);
}
function buttonColorChange(value) {
  let color;
  switch (value) {
    case "yeekee_5":
      color = "hover:bg-yellow-400 bg-yellow-400 text-black";
      break;
    case "yeekee_10":
      color = "hover:bg-orange-400 bg-orange-400 text-white";
      break;
    case "yeekee_15":
      color = "hover:bg-green-500 bg-green-500 text-white";
      break;

    default:
      color = "hover:bg-yellow-500 bg-yellow-500 text-white";
  }
  return color;
}
function toggleDataNext() {
  if (current.value < datas.value.length - 1) {
    current.value++;
  }
}
function toggleDataPrevious() {
  current.value--;
  if (current.value <= 0) {
    current.value = 0;
  }
}
const getResultUpper = () => {
  let array = useArrayFind(
    datas.value,
    (item) => item.round_no == current.value
  );
  if (array.value) {
    if (array.value.results.length > 0) {
      return array.value.results[1].result;
    }
    return "รอผล";
  }
  return "รอผล";
};
const getResultUnder = () => {
  let array = useArrayFind(
    datas.value,
    (item) => item.round_no == current.value
  );
  if (array.value) {
    if (array.value.results.length > 0) {
      return array.value.results[0].result;
    }
    return "รอผล";
  }
  return "รอผล";
};
</script>
